import { useState } from "react";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export const PinForm = ({ caveId, onDone, askName = true }) => {
  const { enterCave } = useAuth();
  const [pin, setPin] = useState("");
  const [name, setName] = useState(localStorage.getItem("cellar_name") || "");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (name) localStorage.setItem("cellar_name", name);
      await enterCave(caveId, pin, name);
      toast.dismiss();
      onDone?.();
    } catch (err) {
      setPin("");
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="pin-form">
      <div>
        <label className="text-xs uppercase tracking-widest text-[#6E665D] mb-2 block">4-digit code</label>
        <Input value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 4))} inputMode="numeric" autoComplete="off" type="password"
          placeholder="••••" className="h-16 text-center text-3xl tracking-[0.8em] font-mono bg-[#161214]" data-testid="pin-input" autoFocus />
      </div>
      {askName && (
        <div>
          <label className="text-xs uppercase tracking-widest text-[#6E665D] mb-2 block">Your name (shown in movements)</label>
          <Input value={name} onChange={(e) => setName(e.target.value)} maxLength={40} placeholder="Optional" className="h-12 bg-[#161214]" data-testid="pin-name-input" />
        </div>
      )}
      <Button type="submit" disabled={pin.length !== 4 || busy || !caveId} className="w-full h-14 text-base bg-[#5C1D24] hover:bg-[#8C2B36] text-[#F5F0EB]" data-testid="pin-submit-button">
        {busy ? "Opening…" : "Open the cellar"}
      </Button>
    </form>
  );
};
